import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
} from "@mui/material";
import { PersonOutlined } from "@mui/icons-material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { store } from "../../redux/store";
import LogoutButton from "./LogoutButton";
import FormRicerca from "./FormRicerca";

const DrawerContent = ({ handleDrawerToggle = () => {} }) => {

  const navigate = useNavigate();

  const { user } = store.getState();

  return (
    <div>
      <Toolbar>
        <Box
          onClick={() => navigate("/")}
          sx={{
            cursor: "pointer",
            alignContent: "center",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <img
            alt="logo"
            src={require("../../assets/images/logo-appello.png")}
            style={{ width: "80%", marginTop: 10, marginBottom: 10 }}
          />
        </Box>
      </Toolbar>
      <Divider />
      <List>
        <ListItem key={"currentuser"} disablePadding>
          <ListItemButton>
            <ListItemIcon>
              <PersonOutlined />
            </ListItemIcon>
            <ListItemText primary={user.nome} />
          </ListItemButton>
        </ListItem>
      </List>
      <List>
      {user.tipoutente === "I" ? (
        
        <FormRicerca handleDrawerToggle={handleDrawerToggle} />

      ) : null}
      </List>
      <Divider />
      <LogoutButton user={user} />
    </div>
  );
};

export default DrawerContent;
